<template>
    <div id="bene-bill-payment-container">
        <f7-list form class="form-group" v-if="showFormSet.billPayment">
            <BeneficiaryBillPaymentBillCorp
                @changeBillCorp="changeBillCorp"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <f7-list-input
                input-id     ="billerCode"
                name         ="billerCode"

                v-if         ="showFormInput.billPayment.billerCode"
                :label       ="$t('beneficiary-bill-code')"
                :placeholder ="$t('beneficiary-bill-code')"
                :value       ="billerCode"

                disabled
                outline
                floating-label
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    // import BeneficiaryBillPaymentBillCorp from '../components/beneficiary-bill-payment-bill-corp.vue';
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'billCorporationId',
                'billCorporationList',
                'billCorporationName',
                'billerCode',
            ])
        },
        components: {
            BeneficiaryBillPaymentBillCorp: () => import('../components/beneficiary-bill-payment-bill-corp.vue'),
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBillCorp',
                'setBillerCode',
                'setBillCorporationList',
            ]),

            changeBillCorp(name) {
                this.$emit("changeBillCorp", name);
            },

            validateInput(inputEl) {
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl) {
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>